export type SchemaStandardRequirement = 'Required' | 'Optional';
export interface SchemaStandardBaseDefinition {
  requirement: SchemaStandardRequirement | null;
}

export type StringPropertyDefinition = SchemaStandardBaseDefinition;
export type StringArrayPropertyDefinition = SchemaStandardBaseDefinition;
export type BooleanPropertyDefinition = SchemaStandardBaseDefinition;

interface SchemaNumberRange {
  min: number | null;
  max: number | null;
}

export type NumberPropertyDefinition = {
  range: SchemaNumberRange;
} & SchemaStandardBaseDefinition;

export type OptionsPropertyDefinition = {
  options: string[];
} & SchemaStandardBaseDefinition;

export function isStandardSchemaPropertyDefinition(
  definition: any
): definition is SchemaStandardBaseDefinition {
  return definition && 'requirement' in definition;
}

export function isStandardBaseDefinitionRequired(
  definition: SchemaStandardBaseDefinition
): boolean {
  return definition?.requirement === 'Required';
}
